<template>
<!-- 数组输入框组件 -->
<!-- 接收一个字符串数组 -->
<!-- 转换成对象数组 -->
<!-- 接受一个方法 GetArrList -->
<!-- 返回字符串数组 -->
  <div>
    <div v-for="(item,index) in ArrList" :key="index">
      <el-input v-model="item.value" size="mini" class="Form-Input-Width"></el-input>
      <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            class="Form-Buttom"
            @click="AddInput"
            v-if="index==ArrList.length-1"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-minus"
            size="mini"
            class="Form-Buttom"
            @click="DeleTeInput(index)"
            v-else
          ></el-button>
    </div>
  </div>  
</template>
<script>
export default {
  props:['List'],
  data(){
    return{
      ArrList:[]
    }
  },
  methods:{
    //添加输入框
    AddInput(){
      this.ArrList.push({value:''})
    },
    //删除输入框
    DeleTeInput(index){
      this.ArrList.splice(index,1)
    },
    //转换成字符串数组
    SetArrList(Arr){
      //创建字符串数组
      let ArrList=[]
      //筛选不为空的对象数组
      Arr.map((val,index)=>{
        if(val.value!==''){
          ArrList.push(val.value)
        }
      })
      // console.log(ArrList)
      //返回字符串数组
      return ArrList
    },
    //验证
    ArrAddInputError(){
      let test=/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      let retu=false
      this.ArrList.forEach((val,index)=>{
        if(!test.test(val.value)){
          this.error=true
          retu=true
          return
        }
      })
      if(!retu){
        this.error=false
      }
    }
  },
  mounted(){
    setTimeout(()=>{
      if(this.List.length>0){
        this.ArrList=this.List.map((val,index)=>{return {value:val}})
      }
      else {
        this.ArrList=[]
        this.ArrList.push({value:''})
      }
    },1500)
  },
  watch:{
    ArrList:{
      handler(newvalue,oldValue){
        //返回字符串数组
        this.$emit('GetArrList',this.SetArrList(this.ArrList))
      },
      deep: true
    },
    List:{
      handler(newValue,oldValue){
        // console.log(newValue)
      }
    },
    deep:true
  }
}
</script>
<style scoped>
.Form-Input-Width {
  width: 5rem;
}
.Form-Buttom {
  margin-left: 0.2rem;
}
</style>
